export default __webpack_public_path__ + "static/media/X.991d7bfe.svg";